import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAnticipation = (id) => useQuery({ queryKey: [`anticipation`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/anticipations/${id}`)
    return callback?.data
}})

export default useAnticipation